var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSortDesc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4142 13C9.52331 13 9.07714 14.0771 9.70711 14.7071L11.2929 16.2929C11.6834 16.6834 12.3166 16.6834 12.7071 16.2929L14.2929 14.7071C14.9229 14.0771 14.4767 13 13.5858 13H10.4142Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4142 11C9.52331 11 9.07714 9.92286 9.70711 9.29289L11.2929 7.70711C11.6834 7.31658 12.3166 7.31658 12.7071 7.70711L14.2929 9.29289C14.9229 9.92286 14.4767 11 13.5858 11H10.4142Z",
    fill: "#E0E0E0"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDesc);
export default ForwardRef;